export default "__VITE_ASSET__Bm785_Pa__"